import React from "react";
import { Button, NewTab } from "../../../../components";

const TabPage1 = ({ setActiveTab }) => (
  <div className="w-full flex-1 flex justify-center items-center">
    <Button title="Next" onClick={() => setActiveTab(1)} />
  </div>
);

const TabPage2 = ({ setActiveTab }) => (
  <div className="w-full flex-1 flex justify-center items-center gap-5">
    <Button title="prev" onClick={() => setActiveTab(0)} />
    <Button title="Next" onClick={() => setActiveTab(2)} />
  </div>
);

const TabPage3 = ({ setActiveTab }) => (
  <div className="w-full flex-1 flex justify-center items-center gap-5">
    <Button title="prev" onClick={() => setActiveTab(1)} />
  </div>
);

const TabNextPrev = () => {
  const tabList = [
    {
      title: "Tab1",
      page: <TabPage1 />,
      type: "main",
    },
    {
      title: "Tab2",
      page: <TabPage2 />,
      type: "main",
    },
    {
      title: "Tab3",
      page: <TabPage3 />,
      type: "main",
    },
  ];
  return (
    <div className="p-6 flex-1 flex ">
      <NewTab
        tabs={tabList}
        color="black"
        variant="outlined"
        mode="url"
        tabId="tab-next-prev"
      />
    </div>
  );
};

export default TabNextPrev;
